<template>
    <transition name="fade">
        <div v-if="loading || hasPendingRequest" class="fullscreen-spinner-blackout">
            <p class="display-2 fullscreen-spinner-text">Um momento...</p>
            <pulse-loader loading size="20px" color="white" class="fullscreen-spinner"></pulse-loader>
        </div>
    </transition>
</template>

<script>
    import Vue from 'vue'
    import { mapGetters, mapMutations } from 'vuex'
    export default {
        props: {
            loading: {
                type: [Boolean],
                default: false
            }
        },
        computed: mapGetters({
            hasPendingRequest: 'showFullscreenLoadingSpinner'
        })
    }

</script>

<style>
    .fullscreen-spinner-blackout {
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background: rgba(0, 0, 0, 0.5);
    }

    .fullscreen-spinner {
        position: fixed;
        top: 50%;
        left: 50%;
        margin-left: -36px;
    }

    .fullscreen-spinner-text {
        position: fixed;
        width: 100%;
        text-align: center;
        top: 35%;
        color: white;
        text-shadow: 3px 3px 1px #333;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
</style>


// WEBPACK FOOTER //
// FullscreenSpinner.vue?33aac11c